import React from 'react';
import {
    StyledWrapper,
    StyledBorder,
} from 'src/features/common/explore/components/explore-header/explore-header.styles';
import { PageTitle } from 'src/ui/common/layouts/page-title';

interface IProps {
    title: string;
    withBorder?: boolean;
}

export const ExploreHeader: React.FC<IProps> = ({ title, withBorder = false, children }) => (
    <>
        <StyledWrapper alignItems="center" justifyContent="space-between">
            <PageTitle>{title}</PageTitle>
            {children}
        </StyledWrapper>
        {withBorder && <StyledBorder />}
    </>
);
